module.exports = __webpack_public_path__ + "static/media/45_tn.35b6cb23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/45_tn.jpg
// module id = 354
// module chunks = 0